import { render, staticRenderFns } from "./RegistrosDefesaComercial.vue?vue&type=template&id=a9d82dbc&scoped=true&"
import script from "./RegistrosDefesaComercial.vue?vue&type=script&lang=js&"
export * from "./RegistrosDefesaComercial.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosDefesaComercial.vue?vue&type=style&index=0&id=a9d82dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d82dbc",
  null
  
)

export default component.exports